(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const offsetWhatsAppButton = () => {
      const widget = document.querySelector('gty-whatsapp-chat-button');
      const shadowRoot = widget?.shadowRoot;

      if (!shadowRoot) return false;

      let offsetStyle = shadowRoot.querySelector('[data-mobile-sticky-whatsapp-offset]');

      if (!offsetStyle) {
        offsetStyle = document.createElement('style');
        offsetStyle.setAttribute('data-mobile-sticky-whatsapp-offset', '');
        shadowRoot.appendChild(offsetStyle);
      }

      offsetStyle.textContent = `
        @media screen and (max-width: 749px) {
          .gty-wacb-wrapper {
            bottom: calc(8.4rem + env(safe-area-inset-bottom)) !important;
          }
        }
      `;

      return true;
    };

    const initialize = (root) => {
      if (root.dataset.mobileStickyInitialized === 'true') return;
      root.dataset.mobileStickyInitialized = 'true';

      const formId = root.dataset.productFormId;
      const sectionId = root.dataset.sectionId;
      const stickyButton = root.querySelector('[data-mobile-sticky-submit]');
      const stickyLabel = root.querySelector('[data-mobile-sticky-label]');
      const stickyVariant = root.querySelector('[data-mobile-sticky-variant]');
      const stickyPrice = root.querySelector('[data-mobile-sticky-price]');
      const productInfo = document.getElementById(`ProductInfo-${sectionId}`);

      const getProductForm = () => document.getElementById(formId);
      const getOriginalButton = () => getProductForm()?.querySelector('.product-form__submit');

      const sync = () => {
        const originalButton = getOriginalButton();
        const variantPicker = productInfo?.querySelector('variant-selects');
        const selectedValues = variantPicker
          ? Array.from(variantPicker.querySelectorAll('select')).map((select) => select.value).filter(Boolean)
          : [];
        const priceContainer = document.getElementById(`price-${sectionId}`);
        const currentPrice = priceContainer?.querySelector('.price-item--sale, .price-item--regular');

        if (selectedValues.length > 0) {
          stickyVariant.textContent = selectedValues.join(' / ');
          stickyVariant.hidden = false;
        }

        if (currentPrice?.textContent.trim()) {
          stickyPrice.textContent = currentPrice.textContent.trim();
        }

        if (originalButton) {
          stickyButton.disabled = originalButton.disabled;
          const originalLabel = originalButton.querySelector('span')?.textContent.trim();
          if (originalLabel) stickyLabel.textContent = originalLabel;
        }
      };

      stickyButton.addEventListener('click', () => {
        const originalButton = getOriginalButton();
        if (originalButton && !originalButton.disabled) originalButton.click();
      });

      productInfo?.addEventListener('change', () => {
        window.setTimeout(sync, 0);
        window.setTimeout(sync, 350);
      });

      if (productInfo) {
        new MutationObserver(sync).observe(productInfo, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['disabled', 'value'],
        });
      }

      document.body.classList.add('mobile-sticky-purchase-active');
      sync();
    };

    document.querySelectorAll('[data-mobile-sticky-purchase]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-mobile-sticky-purchase]').forEach(initialize);
    });

    offsetWhatsAppButton();
    customElements.whenDefined('gty-whatsapp-chat-button').then(() => {
      offsetWhatsAppButton();
      window.setTimeout(offsetWhatsAppButton, 500);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
